import { apiUrl } from "../config/api";
import { userAuthHeaders } from "./authHeaders";

function findMatchedUser(users, currentUser) {
  if (!Array.isArray(users) || !currentUser) {
    return null;
  }

  const currentId = currentUser.id != null ? String(currentUser.id) : null;
  const currentPhone = currentUser.phone || currentUser.identifier || null;

  return (
    users.find((item) => item?.id != null && currentId && String(item.id) === currentId) ||
    users.find((item) => currentPhone && (item?.phone === currentPhone || item?.identifier === currentPhone)) ||
    null
  );
}

function normalizePortalDetails(payload, currentUser) {
  if (!payload || typeof payload !== "object") {
    return null;
  }

  if (payload.user) {
    return {
      ...payload,
      user: {
        ...currentUser,
        ...payload.user,
      },
      transactions: payload.transactions || [],
      statement: payload.statement || [],
    };
  }

  const matchedUser = findMatchedUser(payload.users, currentUser);

  if (!matchedUser) {
    return null;
  }

  return {
    status: payload.status || "success",
    user: {
      ...currentUser,
      ...matchedUser,
    },
    transactions: payload.transactions || [],
    statement: payload.statement || [],
    fallback: true,
  };
}

export async function fetchUserPortalDetails() {
  const userData = localStorage.getItem("user");

  if (!userData) {
    throw new Error("اطلاعات کاربر در دسترس نیست.");
  }

  const currentUser = JSON.parse(userData);
  const response = await fetch(apiUrl("/api/users/me"), {
    headers: userAuthHeaders(),
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || data.message || "خطا در دریافت اطلاعات کاربر");
  }

  const normalizedData = normalizePortalDetails(data, currentUser);

  if (normalizedData) {
    return normalizedData;
  }

  return {
    status: "success",
    user: currentUser,
    transactions: [],
    statement: [],
    fallback: true,
  };
}
